import {
    GET_ADMIN_LOCATION_SUCCESS, GET_ADMIN_LOCATION_ERROR, GET_ADMIN_LOCATION_REQUEST, ADD_ADMIN_LOCATION_ERROR, ADD_ADMIN_LOCATION_REQUEST, ADD_ADMIN_LOCATION_SUCCESS,
    UPDATE_ADMIN_LOCATION_ERROR, UPDATE_ADMIN_LOCATION_REQUEST, UPDATE_ADMIN_LOCATION_SUCCESS, DELETE_ADMIN_LOCATION_ERROR, DELETE_ADMIN_LOCATION_REQUEST, DELETE_ADMIN_LOCATION_SUCCESS
} from "./types";
import { BASEURL } from "../../constant/config.js";
import axios from "axios";






export const getAdminLocation = (token, id) => (dispatch) => {
    dispatch({ type: GET_ADMIN_LOCATION_REQUEST });
    return axios({
        method: "POST",
        url: `${BASEURL}getAll/adminLocation`,
        headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token,
        },
        data: { id }
    })
        .then((response) => {
            return dispatch({ type: GET_ADMIN_LOCATION_SUCCESS, payload: response.data });
        })
        .catch((error) => {
            return dispatch({
                type: GET_ADMIN_LOCATION_ERROR,
                payload: error.response,
            });
        });
};

export const addAdminLocation = (token, data, id) => (dispatch) => {
    dispatch({ type: ADD_ADMIN_LOCATION_REQUEST });
    return axios({
        method: "POST",
        url: `${BASEURL}create/adminLocation`,
        headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token,
        },
        data,
    })
        .then((response) => {

            return dispatch({ type: ADD_ADMIN_LOCATION_SUCCESS, payload: response.data });
        })
        .catch((error) => {
            return dispatch({
                type: ADD_ADMIN_LOCATION_ERROR,
                payload: error.response,
            });
        });
};


export const updateAdminLocation = (token, data, id) => (dispatch) => {
    dispatch({ type: UPDATE_ADMIN_LOCATION_REQUEST });
    return axios({
        method: "PUT",
        url: `${BASEURL}update/adminLocation/${id}`,
        headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token,
        },
        data,
    })
        .then((response) => {

            return dispatch({ type: UPDATE_ADMIN_LOCATION_SUCCESS, payload: response.data });
        })
        .catch((error) => {
            return dispatch({
                type: UPDATE_ADMIN_LOCATION_ERROR,
                payload: error.response,
            });
        });
};



export const deleteAdminLocation = (token, id) => (dispatch) => {
    dispatch({ type: DELETE_ADMIN_LOCATION_REQUEST });
    return axios({
        method: "DELETE",
        url: `${BASEURL}delete/adminLocation/${id}`,
        headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token,
        },
    })
        .then((response) => {
            return dispatch({ type: DELETE_ADMIN_LOCATION_SUCCESS, payload: response.data });
        })
        .catch((error) => {
            return dispatch({
                type: DELETE_ADMIN_LOCATION_ERROR,
                payload: error.response,
            });
        });
};
